import { get } from '../utils/api';
import { endpoints } from '../endpoints';

// Many loaders ask for cache.json at the same time (startup, sync) - share one request
let pendingCaches = null;

export const getCaches = () => {
  if (!pendingCaches) {
    pendingCaches = get(endpoints.cache.get).finally(() => {
      pendingCaches = null;
    });
  }
  return pendingCaches;
};
